const base = (website) => {
  const testimonials = website.testimonials.map(testimonial => {
    if (testimonial.show) {
      return ({
        client: testimonial.name,
        description: testimonial.description,
        location: testimonial.location,
      });
    }
  })

  return testimonials;
};

const butterfly = (website) => {
  const testimonials = base(website).map((testimonial, i) => {
    if (i % 2 == 0) {
      return (
        {
          ...testimonial,
          isLeft: true
        }
      )
    } else {
      return (
        {
          ...testimonial,
          isRight: true
        }
      )
    }
  });

  return(testimonials);
};


export const TestimonialsFactory = {
  getBase: base,
  getButterfly: butterfly,
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/factories/TestimonialsFactory.js